<template>
  <background-wrapper src="hr-tools-background" ext="png" :media="false" align="top" :z-index="2">
    <div class="tools px-xl-4 px-0">
      <h2 class="h1 text-center" v-html="$t('products.tools.our-tools')" />
      <b-row class="tools__list-included mt-6">
        <Tool v-if="!['firstLevel', 'all'].includes(currentRouteGroup)" :route="firstLevelRouts[0]" :tag="$t('products.tools.first-level')" horizontal="horizontal"/>
        <Tool v-else v-for="route in firstLevelRouts" :key="route.name" :route="route" :tag="$t('products.tools.included')" horizontal="horizontal"/>
      </b-row>
      <b-row class="tools__list-add-on">
        <Tool v-if="!['firstLevel', 'all'].includes(currentRouteGroup)" :route="firstLevelRouts[1]" :tag="$t('products.tools.first-level')"/>
        <Tool v-for="route in addOnRouts" :key="route.name" :route="route" :tag="$t(`products.tools.${currentRouteGroup === 'all' ? 'included' : 'add-on'}`)"/>
        <Tool v-for="route in routes('commingSoon')" :key="route.name" :route="route" :tag="$t('products.tools.coming-soon')"/>
      </b-row>
      <template v-if="allInOneRouts.length">
        <h2 class="h1 text-center mt-4 pt-2" v-html="$t('products.tools.why-not')" />
        <b-row class="tools__list-all mt-5 pt-2">
          <Tool v-for="route in allInOneRouts" :key="route.name" :route="route" :tag="$t('products.tools.all-in-one')" horizontal="horizontal"/>
        </b-row>
      </template>
    </div>
  </background-wrapper>
</template>

<script>
import Tool from '../products/Tool.vue'

function routes (productRoutes, groupName, currentRouteName) {
  return productRoutes.filter(route => route.name !== currentRouteName && route.groups && route.groups[groupName]).sort((a, b) => a.groups[groupName] - b.groups[groupName])
}

export default {
  name: 'Tools',
  data () {
    return {
      routes: function (groupName) {
        return this.productRoutes.filter(route => route.name !== this.$route.name && route.groups && route.groups[groupName]).sort((a, b) => a.groups[groupName] - b.groups[groupName])
      }
    }
  },
  computed: {
    productRoutes () { return this.$router.options.routes.find(route => route.name === 'Product').children },
    currentRouteGroup () { return Object.keys(this.productRoutes.find(route => route.name === this.$route.name).groups)[0] },
    firstLevelRouts () { return routes(this.productRoutes, 'firstLevel', this.$route.name) },
    addOnRouts () { return routes(this.productRoutes, 'addOn', this.$route.name) },
    allInOneRouts () { return routes(this.productRoutes, 'allInOne', this.$route.name) }
  },
  components: { Tool }
}
</script>

<style lang="sass" scoped>
.tools
  padding-top: 90px
  position: relative
  z-index: 2

  &__list-included,
  &__list-all
    justify-content: center

  &__list-add-on
    justify-content: center
</style>



// WEBPACK FOOTER //
// src/components/ui/products/Tools.vue